module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "epub_toctitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('ul', {
    staticClass: "epub_toc"
  }, [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157755"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157755"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157756"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157756"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157757"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157757"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157758"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157758"
    }
  }, [_vm._v("Part 1: The Basics of Tarot")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157759"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157759"
    }
  }, [_vm._v("Chapter 1: An Introduction to Tarot")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157759_A-157759_41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157759#A-157759_41"
    }
  }, [_vm._v("History of the Tarot")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157759_A-157759_59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157759#A-157759_59"
    }
  }, [_vm._v("Early Tarot Decks")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157759_A-157759_115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157759#A-157759_115"
    }
  }, [_vm._v("Choosing a Tarot Deck")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157759_A-157759_149"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157759#A-157759_149"
    }
  }, [_vm._v("Handling Your Deck")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157759_A-157759_201"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/N157759#A-157759_201"
    }
  }, [_vm._v("Storing Your Cards")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Learning to Interpret the Tarot")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760_A-157760_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760#A-157760_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exploring the Tarot")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760_A-157760_77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760#A-157760_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Four Suits")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760_A-157760_111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760#A-157760_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teach Yourself Tarot")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760_A-157760_147"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760#A-157760_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Use Your Intuition")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760_A-157760_173"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760#A-157760_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where to Begin")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760_A-157760_191"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760#A-157760_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tarot as a Tool for Divination")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157760_A-157760_209"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157760#A-157760_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keep a Tarot Journal")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157761"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157761",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Symbolism in the Tarot Deck")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157761_A-157761_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157761#A-157761_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Symbols in the Suits")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157761_A-157761_99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157761#A-157761_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Power of Numbers")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157761_A-157761_221"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157761#A-157761_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meaning of Color")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157761_A-157761_239"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157761#A-157761_239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Familiar Symbols")])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157762"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157762",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: The Major and Minor Arcana")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Description and Meanings of the Major Arcana")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Introduction to the Trumps")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fool")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Magician")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_161"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The High Priestess")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_205"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Empress")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_247"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emperor")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_293"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hierophant")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_341"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lovers")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_381"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chariot")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_425"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strength")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_473"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hermit")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_515"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wheel of Fortune")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_557"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_557",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_597"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_597",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hanged Man")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_639"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_639",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_679"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_679",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temperance")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_717"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_717",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Devil")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_763"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_763",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tower")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_807"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_807",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Star")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_847"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_847",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moon")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_897"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_897",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sun")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_939"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_939",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgment")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157763_A-157763_977"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157763#A-157763_977",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Suit of Wands")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpreting the Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knight of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_123"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_147"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ace of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_171"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_195"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_219"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_243"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_267"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_291"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_315"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_339"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine of Wands")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157764_A-157764_363"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157764#A-157764_363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten of Wands")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Suit of Pentacles")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpreting the Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knight of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_151"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ace of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_175"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_199"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_223"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_247"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_271"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_295"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_319"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_343"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine of Pentacles")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157765_A-157765_367"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157765#A-157765_367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten of Pentacles")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Suit of Swords")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpreting the Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knight of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_129"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_153"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ace of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_177"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_201"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_225"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_249"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_273"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_297"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_321"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_345"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine of Swords")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157766_A-157766_369"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157766#A-157766_369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten of Swords")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Suit of Cups")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpreting the Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knight of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_121"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_145"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ace of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_169"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_193"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_217"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_241"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_265"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_289"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_313"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_337"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine of Cups")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157767_A-157767_361"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157767#A-157767_361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten of Cups")])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157768"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157768",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Performing Tarot Readings")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: How to Do Readings")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769_A-157769_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769#A-157769_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Focus and Attitude Are Key")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769_A-157769_63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769#A-157769_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ask Clear Questions")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769_A-157769_85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769#A-157769_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understand That the Future Is Not Fixed")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769_A-157769_103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769#A-157769_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading for Yourself")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769_A-157769_223"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769#A-157769_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading for Others")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769_A-157769_261"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769#A-157769_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice Different Spreads")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157769_A-157769_277"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157769#A-157769_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Often Should You Do Readings?")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Tarot Spreads")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770_A-157770_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770#A-157770_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acquainting Yourself with Spreads")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770_A-157770_69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770#A-157770_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing a Significator")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770_A-157770_213"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770#A-157770_213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lay Out the Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770_A-157770_235"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770#A-157770_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpret the Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770_A-157770_261"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770#A-157770_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Which Spread Should You Use?")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770_A-157770_279"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770#A-157770_279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Significance of Trumps in a Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157770_A-157770_305"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157770#A-157770_305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creating Your Own Spreads")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Sixteen Spreads")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Single-Card Method")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yes/No Method")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_133"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Either/Or Method")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_147"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Past-Present-Future Method")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_161"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immediate Situation Three-Card Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_209"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four-Card Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_267"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practical Advice Five-Card Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_335"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Celtic Cross Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_453"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Life Conditions Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_531"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_531",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Answer Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_619"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_619",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Horseshoe Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_707"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_707",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World Tree Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_755"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tree of Life Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_873"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_873",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feng Shui Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_981"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_981",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Horoscope Spread")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157771_A-157771_1149"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157771#A-157771_1149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen-Card Story Spread")])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157772"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157772",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Using the Tarot for Personal Development and Growth")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157772_A-157772_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157772#A-157772_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daily Insights from the Tarot")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157772_A-157772_59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157772#A-157772_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daily Affirmations and the Tarot")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157772_A-157772_75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157772#A-157772_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflecting on the Major Arcana for Inner Truths")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157772_A-157772_97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157772#A-157772_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working with the Minor Arcana for Specific Issues")])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157772_A-157772_127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157772#A-157772_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connect with Your Intuition")])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "epub_tocitem",
    attrs: {
      "id": "N157773"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/N157773",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Glossary of Terms")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0